import { createRef } from 'react';

export const servicesRef = createRef();

const services = {
  get: (name) => servicesRef.current[name],
};
export default services;
